import axios from 'axios'
axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_API_URL
import create from '@/store/orders/create'
import previus from '@/store/orders/previus'
export default {
	namespaced: true,
	state: {
		models: [],
		model: {},
		display: 'cards',

		delete: null,
		details: null,

		loading: false,
	},
	mutations: {
		setLoading(state, value) {
			state.loading = value
		},
		setModel(state, value = null) {
			if (value) {
				state.model = value
			} else {
				state.model = {
					id: null,
					name: '',
					description: '',
					price: '',
				}
			}
		},
		setModels(state, value) {
			state.models = value
		},
		add(state, value) {
			let index = state.models.findIndex(item => {
				return item.id == value.id
			})
			if (index == -1) {
				state.models.unshift(value)
			} else {
				state.models.splice(index, 1, value)
			}
		},
		setDisplay(state, value) {
			state.display = value
		},
		setDelete(state, value) {
			state.delete = value
		},
		setDetails(state, value) {
			state.details = value
		},
		setEdit(state, value) {
			state.edit = value
		},
		delete(state) {
			let index = state.models.findIndex(model => {
				return model.id == state.delete.id
			})
			state.models.splice(index, 1)
		},
		update(state, updated) {
			let index = state.models.findIndex(item => {
				return item.id == updated.id
			})
			state.models.splice(index, 1, updated)
		},
	},
	actions: {
		getModels({ commit }) {
			commit('setLoading', true)
			return axios.get('/api/orders')
			.then(res => {
				commit('setLoading', false)
				commit('setModels', res.data.orders)
			})
			.catch(err => {
				commit('setLoading', false)
				console.log(err)
			})
		},
		delete({ commit, state }) {
			return axios.delete('/api/orders/'+state.delete.id)
			.then(() => {
				commit('delete')
			})
			.catch((err) => {
				console.log(err)
			})
		},
	},
	modules: {
		create,
		previus,
	},
}
